// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../generated-types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ModelSettingsQueryVariables = Types.Exact<{
  matterportId: Types.Scalars["String"];
}>;

export type ModelSettingsQuery = {
  __typename?: "Query";
  getModelSettings: {
    __typename?: "ModelSettings";
    bookingEmail?: string | null;
    bookingURL?: string | null;
    brandColor?: string | null;
    buttonLabel?: string | null;
    showEnquiryButtonByDefault?: boolean | null;
    venueDetails?: string | null;
    openingReelID?: string | null;
  };
};

export const ModelSettingsDocument = gql`
  query ModelSettings($matterportId: String!) {
    getModelSettings(matterportID: $matterportId) {
      bookingEmail
      bookingURL
      brandColor
      buttonLabel
      showEnquiryButtonByDefault
      venueDetails
      openingReelID
    }
  }
`;

export function useModelSettingsQuery(
  options: Omit<Urql.UseQueryArgs<ModelSettingsQueryVariables>, "query">
) {
  return Urql.useQuery<ModelSettingsQuery>({
    query: ModelSettingsDocument,
    ...options,
  });
}
